import Navbar from "./components/navbar/Navbar";
import HomePage from "./page/HomePage";


function App() {
  return (
    <div className="App">
       <Navbar/>
      <HomePage />
    </div>
  );
}

export default App;
